import { ICall } from './../../services/api/calls/callsApi';
export const calculateCallDuration = (call: ICall) => {
    // If duration_seconds is available, use it
    if (call.duration_seconds) {
      return Math.floor(call.duration_seconds);
    }
    
    // Otherwise calculate from start_time and end_time
    if (call.start_time && call.end_time) {
      // Handle both string and Date types
      const startTime = new Date(call.start_time);
      const endTime = new Date(call.end_time);
      
      // Check if dates are valid
      if (!isNaN(startTime.getTime()) && !isNaN(endTime.getTime())) {
        const durationMs = endTime.getTime() - startTime.getTime();
        return Math.floor(durationMs / 1000); // Convert to seconds
      }
    }
    
    return 0;
  };


export function toAppointmentDatetimeISO(appointmentDate: string | undefined, startTime: string): string {
      const direct = new Date(startTime);
      if (!Number.isNaN(direct.getTime()) && /\d{4}-\d{2}-\d{2}/.test(startTime)) {
          return direct.toISOString();
      }
  
      // Otherwise, combine calendar date + HH:mm.
      const datePart = appointmentDate || new Date().toISOString().split('T')[0];
      const timeMatch = startTime.match(/(\d{1,2}):(\d{2})/);
      const hhmm = timeMatch
          ? `${timeMatch[1].padStart(2, '0')}:${timeMatch[2]}`
          : '09:00';
      const combined = new Date(`${datePart}T${hhmm}:00`);
      if (!Number.isNaN(combined.getTime())) return combined.toISOString();
  
      return new Date().toISOString();
  }

  export function getErrorMessage(error: unknown, fallback: string): string {
      if (!error || typeof error !== 'object') return fallback;
      const maybeResponse = (error as { response?: { data?: { message?: unknown } } }).response;
      const message = maybeResponse?.data?.message;
      return typeof message === 'string' && message.trim() ? message : fallback;
  }

  export function languageCodeToName(code: string): string {
    if (!code || !code.trim() || code === 'undefined') return 'English'; // Default to English if code is falsy
    const mapping: Record<string, string> = {
      en: 'English',
      es: 'Spanish',
      fr: 'French',
      de: 'German',
      yo: 'Yoruba',
    };
    return mapping[code] || code;
  }
  